import type { CreateHouseholdDto } from 'api/btlApplicationForm/types';

function toNonNegativeNumber(value: unknown): number {
  if (typeof value === 'number' && Number.isFinite(value) && value >= 0) {
    return value;
  }

  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);

    if (Number.isFinite(parsed) && parsed >= 0) {
      return parsed;
    }
  }

  return 0;
}

function pickNumber(source: Record<string, unknown> | undefined, key: string): number {
  return toNonNegativeNumber(source?.[key]);
}

export function mapOoExpensesFormValuesToHousehold(values: Record<string, unknown>): CreateHouseholdDto {
  const income = (values.income as Record<string, unknown> | undefined) ?? {};
  const declaredExpenditure = (values.declaredExpenditure as Record<string, unknown> | undefined) ?? {};
  const creditCommitments = (values.creditCommitments as Record<string, unknown> | undefined) ?? {};

  return {
    numberOfDependents13OrUnder: toNonNegativeNumber(values.numberOfDependents13OrUnder),
    numberOfDependentsOver13: toNonNegativeNumber(values.numberOfDependentsOver13),
    income: {
      childBenefit: pickNumber(income, 'childBenefit'),
      childTaxCredit: pickNumber(income, 'childTaxCredit'),
      workingTaxCredit: pickNumber(income, 'workingTaxCredit'),
      industrialInjuriesDisablementBenefit: pickNumber(income, 'industrialInjuriesDisablementBenefit'),
      personalIndependencePayment: pickNumber(income, 'personalIndependencePayment'),
    },
    declaredExpenditure: {
      travel: pickNumber(declaredExpenditure, 'travel'),
      childcare: pickNumber(declaredExpenditure, 'childcare'),
      csaMaintenance: pickNumber(declaredExpenditure, 'csaMaintenance'),
      councilTax: pickNumber(declaredExpenditure, 'councilTax'),
      serviceChargeGroundRent: pickNumber(declaredExpenditure, 'serviceChargeGroundRent'),
      other: pickNumber(declaredExpenditure, 'other'),
      basicEssentialLiving: pickNumber(declaredExpenditure, 'basicEssentialLiving'),
      basicQualityOfLiving: pickNumber(declaredExpenditure, 'basicQualityOfLiving'),
      dependantMaintenance: pickNumber(declaredExpenditure, 'dependantMaintenance'),
      educationFees: pickNumber(declaredExpenditure, 'educationFees'),
    },
    creditCommitments: {
      creditCardBalance: pickNumber(creditCommitments, 'creditCardBalance'),
      buyNowPayLater: pickNumber(creditCommitments, 'buyNowPayLater'),
      unsecuredLoans: pickNumber(creditCommitments, 'unsecuredLoans'),
      securedLoans: pickNumber(creditCommitments, 'securedLoans'),
      unsecuredLoansOnRevertDate: pickNumber(creditCommitments, 'unsecuredLoansOnRevertDate'),
    },
  } as CreateHouseholdDto;
}
